import { useRef } from "react";
import useFormEventDispatcher from "./EventDispatcher";
import useFormState from "./State";
import useFormActions from "./Actions";

function useForm() {
  const formRef = useRef();
  const {
    loading,
    setLoading,
    showErrorFields, 
    setShowErrorFields
  } = useFormState();
  const dispatchEvent = useFormEventDispatcher({
    setLoading,
  });
  const { onSave, onSubmit, onSubmitClick, onDelete } = useFormActions({
    formRef,
    setShowErrorFields,
    dispatchEvent,
  });
  
  return {
    ref: formRef,
    onSave,
    onSubmit,
    onSubmitClick,
    onDelete,
    loading: loading,
    showErrorForMissingField: showErrorFields,
  };
}

export default useForm;
